import React from 'react';
import PolicyScreen from './screens/Policy/PolicyScreen';

function Policy() {
  return (
    <>
      <PolicyScreen />
    </>
  );
}

export default Policy;
